export const LABEL_MESH_CREATE = 'LABEL_MESH_CREATE';
export const LABEL_MESH_SHOW_TOGGLE = 'LABEL_MESH_SHOW_TOGGLE';

export const LABEL_MESH_UPDATE_SLICE_INDEXES = 'LABEL_MESH_UPDATE_SLICE_INDEXES';
export const LABEL_MESH_UPDATE_INDEX = 'LABEL_MESH_UPDATE_INDEX';

export const LABEL_MESH_CLEAR = 'LABEL_MESH_CLEAR';